import axios from 'axios';
import auth from '@groovepages/gd-lib/auth';
import storage from 'local-storage-fallback';
import showAlert from '@/components/sweet-alert-popup.js';
import store from '@/state';
import themeConfig from '@/theme/themeConfig';

export default {
  computed: {},
  methods: {
    async impersonateLogin(email, appName) {
      const accept = await showAlert({
        iconType: 'alert-question',
        html: `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-lg font-bold text-deep-dark mb-3"> ${this.$t('frontend_bouses_delete_bonus_title')}</p>
          <p class="text-sm text-deep-dark"> ${this.$t('frontend_groovemail_spam_alert_login_to_owner_account')}</p>
        `,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#2f80ed',
        cancelButtonColor: themeConfig.appPrimaryColor,
        cancelButtonText: this.$t('frontend_cancel'),
        confirmButtonText: this.$t(
          'frontend_groovemail_frontend_confirm'
        ),
      });
      if (accept) {
        this.showLoader();
        const userData = JSON.parse(localStorage.getItem('user'));
        const existing_email = userData.email;
        const refresh_token = userData.refresh_token;
        const app_source = this.$route.fullPath;
        axios
          .post(`${window.gdEnv.VUE_APP_API_URL}/grooveadmin/impersonate`, { email, existing_email, refresh_token })
          .then((response) => {
            const adminData = auth.authenticatedUser();
            storage.setItem('adminuser', JSON.stringify(adminData));
            auth.setUserData(response.data,true);            
            store.commit('login', response.data);
            storage.setItem('app_source', app_source);
            storage.setItem('app_name', appName);
            this.hideLoader();
            window.location = '/';
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  }
};
